import axios from "axios";
import { REQUEST_CSRF_TOKEN, SET_CSRF_TOKEN, SET_SESSION_STATUS } from "../actions/types";
import { config, showUserNotification } from "../../utils"

const sendCSRFLoadingRequest = () => {
    return {
        type: REQUEST_CSRF_TOKEN,
        loading: true,
    }
};

const setCSRFToken = (token) => {
    return {
        type: SET_CSRF_TOKEN,
        loading: false,
        token: token,
    }
};

const setSessionStatus = (expired) => {
    return {
        type: SET_SESSION_STATUS,
        expired: expired,
    }
};

const requestCSRFToken = (dispatch) => {
    dispatch(sendCSRFLoadingRequest());
    axios.get(config.serviceUrl + "api/v1/csrf").then(response => {
        let data = response.data;
        if (data.ruleCode === 200)
            dispatch(setCSRFToken(data.csrfToken));
        else
            showUserNotification.error(data.response);
    }).catch(err => {
        showUserNotification.error(err.message);
    });
}


const updateSessionStatus = (dispatch, expired) => {
    dispatch(setSessionStatus(expired));
}

export default {
    requestCSRFToken,
    updateSessionStatus,
}